import { Component, effect, inject, output } from '@angular/core';

import { PointDepart } from '../../models/point-départ.model';
import { EtapeStore } from '../../parcours-etape/store/etape.store';
import { ParcoursStateService } from '../../services/parcours-state.service';
import { Outil } from '../barre-d-outil/barre-d-outil.component';
import { POINTS_DEPART } from '../../models/point.départ.enum';

@Component({
  selector: 'app-parcours-depart',
  templateUrl: './parcours-depart.component.html',
})
export class ParcoursDepartComponent {
  readonly #etapeStore = inject(EtapeStore);
  readonly #parcoursStateService = inject(ParcoursStateService);

  protected readonly profondeurActuelle = this.#parcoursStateService.profondeurActuelle;

  readonly onClick = output<Omit<Outil, 'icon'>>();

  protected pointsDepart: Omit<PointDepart, 'icon'>[] = [
    {
      nodeType: 'Point-Depart',
      titre: 'Post-Collège',
      libelleSchema: POINTS_DEPART.POST_COLLEGE,
      selectionne: false,
      niveau: '01',
    },
    {
      nodeType: 'Point-Depart',
      titre: 'Post-Bac',
      libelleSchema: POINTS_DEPART.POST_BAC,
      selectionne: false,
      niveau: '01',
    },
    {
      nodeType: 'Point-Depart',
      titre: 'Prépa Tour de France',
      sousTitre: 'Niveau 3 acquis',
      libelleSchema: POINTS_DEPART.PREPA_TOUR_FRANCE_NIV_3,
      selectionne: false,
      niveau: '01',
    },
    {
      nodeType: 'Point-Depart',
      titre: 'Prépa Tour de France',
      sousTitre: 'Niveau 4 acquis',
      libelleSchema: POINTS_DEPART.PREPA_TOUR_FRANCE_NIV_4,
      selectionne: false,
      niveau: '01',
    },
    {
      nodeType: 'Point-Depart',
      titre: 'Prépa Tour de France',
      sousTitre: 'Niveau 5 acquis',
      libelleSchema: POINTS_DEPART.PREPA_TOUR_FRANCE_NIV_5,
      selectionne: false,
      niveau: '01',
    },
  ];

  constructor() {
    effect(() =>
      this.pointsDepart.forEach((p) => {
        if (this.#etapeStore.pointsDeDepartActifs().find((e) => e.nom == p.libelleSchema)) {
          p.selectionne = true;
        }
      }),
    );
  }

  protected clickHandler(pointDepart: Omit<PointDepart, 'icon'>) {
    this.onClick.emit(pointDepart);
  }
}
